import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as vinWonderTicketActions from './../../../../actions/vinWonderTicketAction';
import VinWonderTickets from './VinWonderTickets';

const mapStateToProps = state => {
    return {
        vinWonderTicketState: state.vinWonderTicketReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListVinWonderTickets: (filters) => dispatch(vinWonderTicketActions.getListVinWonderTickets(filters)),
        deleteVinWonderTicketDetail: (vinWonderTicket, filters) => dispatch(vinWonderTicketActions.deleteVinWonderTicketDetail(vinWonderTicket, filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(VinWonderTickets));
